import constructVideoSeriesCarousel from '../../hocs/carousel/video_series_carousel';
import Season from './season';
import {get, partial} from 'lodash';

export default constructVideoSeriesCarousel({

  slideType: 'season',

  slideComponent: Season,

  slideProps(slide, idx) {
    return {
      ...slide,
      handleClick: partial(this.props.handleSlideClick, idx),
      isActive: this.props.activeSlideIdx === idx
    };
  },

  uuid() {
    const firstSeasonTitle = get(this.props, 'slides[0].display_name', '');
    return firstSeasonTitle.toLowerCase().replace(/ /g, '-');
  },

  intl() {
    return get(this.props, 'intl');
  }

});
